import { gql } from '@apollo/client';

export const TAGS_PAGE_QUERY = gql`
  query tags(
    $limit: Int!
    $offset: Int!
    $q: String
    $withDeleted: Boolean
    $orderBy: String
    $orderDirection: String
    $columnFilters: [ColumnFilter!]
  ) {
    tags(
      limit: $limit
      offset: $offset
      q: $q
      withDeleted: $withDeleted
      orderBy: $orderBy
      orderDirection: $orderDirection
      columnFilters: $columnFilters
    ) {
      id
      currentVersion {
        id
        deletedAt
        name
        updatedById
        status
        version
      }
    }
    tagsPageInfo(
      q: $q
      columnFilters: $columnFilters
      withDeleted: $withDeleted
    ) {
      totalCount
    }
  }
`;
export const TAGS_QUERY = gql`
  query tags($limit: Int!, $offset: Int!, $q: String) {
    tags(limit: $limit, offset: $offset, q: $q) {
      id
      currentVersion {
        id
        deletedAt
        name
        updatedById
        status
        version
      }
    }
  }
`;

export const TAG_QUERY = gql`
  query tag($id: Int!) {
    tag(id: $id) {
      id
      currentVersion {
        id
        deletedAt
        name
        updatedById
        status
        version
      }
    }
  }
`;

export const TAG_VERSIONS_QUERY = gql`
  query tagVersions($limit: Int, $offset: Int, $tagId: Int!) {
    tagVersions(limit: $limit, offset: $offset, tagId: $tagId) {
      id
        deletedAt
        name
        updatedById
        status
        version
    }
  }
`;
